<template lang="pug">
  #app
    transition(name="slide-fade")
      router-view
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'App',
    created() {
      this.initWx()
    },
    updated() {
      this.initWx()
    },
    methods: {
      initWx() {
        if (/micromessenger/i.test(navigator.userAgent)) {
          let url = window.location.href
          axios.get(`https://mainssl.geekpark.net/api/v1/wechat/js_config?request_url=${encodeURIComponent(url)}`)
            .then((response) => {
              let json = response.data
              let wx = window.wx
              wx.config({
                debug: false,
                appId: json.appId,
                timestamp: json.timestamp,
                nonceStr: json.nonceStr,
                signature: json.signature,
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
              })

              let imgUrl = 'https://summit-img.geekpark.net/frontier/img/wx-sandbox-share-2021.png'
              let desc = '你的第一笔「创业学费」我们替你出'
              let title = '陪伴早期创业者走夜路 | 未来前沿 2021 开放申请中'

              wx.ready(function () {
                wx.onMenuShareTimeline({ // 分享朋友圈
                  title: title, // 分享标题
                  link: url, // 分享链接
                  imgUrl: imgUrl // 分享图标
                })
                wx.onMenuShareAppMessage({ // 分享给好友
                  title: title, // 分享标题
                  desc: desc, // 分享描述
                  link: url, // 分享链接
                  imgUrl: imgUrl // 分享图标
                })
              })
            })
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import './assets/css/main'
  @import './assets/css/var'

  @font-face {
    font-family: 'Noto Sans SC';
    font-style: normal;
    font-weight: 300;
    src: url('//at.alicdn.com/t/hvsgg329ms4i.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('//at.alicdn.com/t/hvsgg329ms4i.woff') format('woff'), /* chrome、firefox */ url('//at.alicdn.com/t/hvsgg329ms4i.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/ url('//at.alicdn.com/t/hvsgg329ms4i.svg#思源黑体-细') format('svg'); /* iOS 4.1- */
  }

  @font-face {
    font-family: 'Noto Sans SC';
    font-style: normal;
    font-weight: 400;
    src: url('//at.alicdn.com/t/3i5q3bka63b4kj4i.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('//at.alicdn.com/t/3i5q3bka63b4kj4i.woff') format('woff'), /* chrome、firefox */ url('//at.alicdn.com/t/3i5q3bka63b4kj4i.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/ url('//at.alicdn.com/t/3i5q3bka63b4kj4i.svg#NotoSansHans-DemiLight') format('svg'); /* iOS 4.1- */
  }

  @font-face {
    font-family: 'Noto Sans SC';
    font-style: normal;
    font-weight: 900;
    src: url('//at.alicdn.com/t/webfont_dw1sf9iit19.eot'); /* IE9*/
    src: url('//at.alicdn.com/t/webfont_dw1sf9iit19.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('//at.alicdn.com/t/webfont_dw1sf9iit19.woff') format('woff'), /* chrome、firefox */ url('//at.alicdn.com/t/webfont_dw1sf9iit19.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/ url('//at.alicdn.com/t/webfont_dw1sf9iit19.svg#NotoSansHans-Black') format('svg'); /* iOS 4.1- */
  }

  @font-face {
    font-family: 'FZLTTHCJW--GB1-0';
    src: url('./assets/fonts/fzlt.ttf') format('truetype');
  }

  @font-face {
    font-family: 'BebasNeue';
    src: url('./assets/fonts/BebasNeue.otf') format('truetype');
  }

  #app {
    font-family: "PingFang SC", "Lantinghei SC", "Helvetica Neue", "Noto Sans SC", Helvetica, Arial, "Microsoft YaHei", "微软雅黑", "STHeitiSC-Light", "simsun", "宋体", "WenQuanYi Zen Hei", "WenQuanYi Micro Hei", "sans-serif";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: rgb(14, 14, 23);
    position: relative;
    overflow: hidden;
    padding-top: 72px;
  }

  html, body, #app {
    width: 100%;
    overflow-x: hidden;
    background-color #0f0f18;
  }

// .big-event-gray{
//   -webkit-filter: grayscale(100%);
//   -moz-filter: grayscale(100%);
//   -ms-filter: grayscale(100%);
//   -o-filter: grayscale(100%);
//   filter: grayscale(100%);
//   filter: gray;
// }

  .container
    margin 0 auto
    width 100%
    max-width 1080px

  @media $media
    #app
      padding-top 50px

    .container
      box-sizing border-box
      padding-left 20px
      padding-right 20px
</style>



// WEBPACK FOOTER //
// App.vue?75f06c38